import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";
import { FaChartGantt } from "react-icons/fa6";
import Productivity from "./index";
import { MODULE_PRODUCTIVITY } from "variables/modules";

const productivityRoutes = [	
    generateCRUDRoutes({
        mainTitle: "Productivity Tracking",
        basePath: "productivity",
        mainComponent: <Productivity/>,
        layout: "/console", 
        icon: <FaChartGantt className="icon-item" />,
        subTitle:"Productivity Tracking",
        level:5,
        moduleId: MODULE_PRODUCTIVITY,
    })
]

export default productivityRoutes;